import { isEmail, isPhoneNumber, isURL } from "class-validator";
import { endOfYesterday, isAfter, parseISO } from "date-fns";
export const validators = {
    notBlank: (value) => value !== "",
    notNull: (value) => value !== null,
    validZIP: (value) => !!value.match(/^[0-9]{5}$/),
    validURL: (value) => value !== "" ? isURL(value, { protocols: ["http", "https"], require_tld: false, require_protocol: true }) : true,
    validEmail: (value) => (value !== "" ? isEmail(value) : true),
    validPhone: (value) => (value !== "" ? isPhoneNumber(value, "US") : true),
    positiveNumber: (value) => {
        if (value === null)
            return true;
        const parsed = typeof value === "number" ? value : parseInt(value);
        return !Number.isNaN(parsed) && parsed > 0;
    },
    futureDate: (value) => {
        if (value === null)
            return true;
        const parsed = parseISO(value);
        return isAfter(parsed, endOfYesterday());
    },
    validIAMRoleARN: (value) => value.match(/arn:aws:iam::\w+:role\/.*/) !== null,
    validDataDeliveryPath: (value) => {
        if (value === "")
            return true;
        const allowedParams = ["orgId", "externalId", "healthexPatientId", "dataType", "projectId", "timestamp"];
        const paramRegex = /\{([^}]+)\}/g;
        let match;
        while ((match = paramRegex.exec(value)) !== null) {
            const paramName = match[1];
            if (!allowedParams.includes(paramName)) {
                return false;
            }
        }
        return true;
    },
};
